<template>
    <v-tabs fixed-tabs class="tab-component">
        <template v-for="item in items">
            <v-tab :key="item">{{ item }}</v-tab>
        </template>
    </v-tabs>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            require: true,
            default: ["item1" , "Item2", "Item3", "Item4"],
        }
    }
}
</script>